import { Box } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { tokens } from '@synergy/theme-palo';

const c = tokens.color;

export interface PaloPositionSumEntry {
    label: ReactNode;
    value: ReactNode;
    /** Emphasised entry, e.g. the gross total. */
    total?: boolean;
}

export interface PaloPositionSumProps {
    entries: PaloPositionSumEntry[];
}

/**
 * The prototype's `.pos-sum`: right-aligned totals under the position table,
 * labels small and muted, values in equal-width digits, the total one step larger.
 * Purely presentational — the caller decides where the numbers come from.
 */
export const PaloPositionSum = ({ entries }: PaloPositionSumProps): ReactElement => (
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '26px',
            padding: '11px 13px',
            backgroundColor: c.surfaceAlt,
            borderTop: `1px solid ${c.lineHard}`,
        }}
    >
        {entries.map((entry, index) => (
            <Box key={index} sx={{ textAlign: 'right' }}>
                <Box sx={{ fontSize: '10.5px', color: c.ink3 }}>{entry.label}</Box>
                <Box
                    sx={{
                        fontFamily: tokens.font.sans,
                        fontVariantNumeric: 'tabular-nums',
                        fontWeight: 620,
                        marginTop: '1px',
                        fontSize: entry.total ? '18px' : '14px',
                        color: entry.total ? c.ink : undefined,
                    }}
                >
                    {entry.value}
                </Box>
            </Box>
        ))}
    </Box>
);
